import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SharedModule],
    templateUrl: './app.component.html'
})
export class AppComponent {
}
